/**
 * @file 全ページ共通で使用するjsファイル
 *
 */

import '../../modules/*';
